import * as React from 'react';
import { OffboardingPage } from './OffboardingPage';

const DefenderOffboarding: React.FunctionComponent = () => (
  <OffboardingPage taskDefId="defender-app" heading="Defender" />
);

export { DefenderOffboarding };
